import { useNavigate } from 'react-router-dom'

import { Wizard } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { CategoryOption, WizardData } from 'modules/finance/lib/policy_types'

import { basicInfoStep } from './BasicInfo'
import { policyTemplateStep } from './PolicyTemplate'

interface Props {
  onSuccess: (policyId: string) => void
  onError: () => void
  categories: CategoryOption[]
  subcategories: CategoryOption[]
}

export const NewSpendingPoliciesWizard = ({
  onSuccess,
  onError,
  categories,
  subcategories,
}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const initialData: WizardData = {
    categories: [],
    subcategories: [],
    availableCategories: categories,
    availableSubcategories: subcategories,
    template: '',
    success: false,
    errors: {},
    icon: 'academic-cap',
    description: '',
    name: '',
  }

  const handleSubmit = async (data: WizardData) => {
    data.success && data.policyId ? onSuccess(data.policyId) : onError()
  }

  return (
    <Wizard.Modal
      size="large"
      onClose={() => navigate(navigation.expenses.spendingPolicies.fullPath())}
      title={i18n.t('spending_policies.wizard.title')}
      description={i18n.t('spending_policies.wizard.description')}
      icon="newspaper"
      steps={[policyTemplateStep(), basicInfoStep()]}
      initialData={initialData}
      onSubmit={handleSubmit}
    />
  )
}
